module.exports = __webpack_public_path__ + "static/media/game.a2aac7d5.png";